import { I18n } from 'utils/i18n';

export const isRuleManagedTeamValue = value => (value?.ruleCount || 0) > 0;

export const mapTeamPickerOption = option => {
  const ruleManaged = isRuleManagedTeamValue(option?.value);
  return {
    ...option,
    isDisabled: ruleManaged,
    title: ruleManaged ? I18n.t('EmployeeDrawer.RuleManagedTeam') : undefined,
  };
};
